import { render, staticRenderFns } from "./TelegramSync.vue?vue&type=template&id=690ab89b&"
import script from "./TelegramSync.vue?vue&type=script&lang=js&"
export * from "./TelegramSync.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports